import merchantGatewayApi from 'apis/merchant-gateway/api';

import { MenuApiCredentialMetadata, MenuApiCredentials, VenueOperationPayload } from './types';

const BaseEndpoint = '/pos-integration-service/menu/access';

export const fetchMenuApiUsers = (merchantId: string): Promise<MenuApiCredentialMetadata[]> =>
  merchantGatewayApi.get<MenuApiCredentialMetadata[]>(`${BaseEndpoint}/${merchantId}`).then(response => response.data);

export const fetchMenuApiUser = (merchantId: string, username: string): Promise<MenuApiCredentials> =>
  merchantGatewayApi
    .get<MenuApiCredentials>(`${BaseEndpoint}/${merchantId}/${username}`)
    .then(response => response.data);

export const createMenuApiUser = (merchantId: string, username: string): Promise<MenuApiCredentials> =>
  merchantGatewayApi
    .post<MenuApiCredentials>(`${BaseEndpoint}/${merchantId}/${username}`)
    .then(response => response.data);

export const resetPasswordOfMenuApiUser = (merchantId: string, username: string): Promise<MenuApiCredentials> =>
  merchantGatewayApi
    .patch<MenuApiCredentials>(`${BaseEndpoint}/${merchantId}/${username}`)
    .then(response => response.data);

export const batchProcessVenuesToMenuApiUser = (
  merchantId: string,
  username: string,
  payload: VenueOperationPayload,
): Promise<boolean> =>
  merchantGatewayApi.patch<boolean>(`${BaseEndpoint}/${merchantId}/${username}/venue`, payload).then(_ => true);

export const addVenueToMenuApiUser = (merchantId: string, username: string, venueId: string): Promise<boolean> =>
  merchantGatewayApi.put<boolean>(`${BaseEndpoint}/${merchantId}/${username}/venue/${venueId}`).then(_ => true);

export const removeVenueToMenuApiUser = (merchantId: string, username: string, venueId: string): Promise<boolean> =>
  merchantGatewayApi.delete<boolean>(`${BaseEndpoint}/${merchantId}/${username}/venue/${venueId}`).then(_ => true);
